module.exports = __webpack_public_path__ + "media/recipes/72-810c4014.png";